// extracted by mini-css-extract-plugin
export var details = "_dq-0";
export var inspectorPopover = "_dq-1";